export default "__VITE_ASSET__CWYXsuWD__"